'use client';

import { FC, ReactNode } from 'react';

import { useIsAuthorized } from '@telialt/utils/src/SSO/useIsAuthorized';

import { AllEntryTypes } from '../../models/Content';
import { getBlockVisibility, shouldRenderBlock } from '../../utils/shouldRenderBlock';

type Props = {
    contentItem?: AllEntryTypes;
    children: ReactNode;
};

export const BlockVisibility: FC<Props> = ({ contentItem, children }) => {
    const isAuthorized = useIsAuthorized();

    if (!shouldRenderBlock(getBlockVisibility(contentItem), isAuthorized)) {
        return null;
    }

    return children;
};
